import jQuery from "jquery";
import "jquery-validation";
import {App} from "./app/app";

import "js-datepicker";
import "./misc/datefield";

import build_config from "../../../server/build/wrb_build_config";

console.log("Loading main.ts", jQuery);

function init() {

    console.log("build_config", build_config);

    console.log("INIT...");

    function shiftHandler(event: KeyboardEvent) {
        const shift = event.shiftKey;
        if (shift) {
            document.body.classList.add("shift")
        } else {
            document.body.classList.remove("shift")
        }
    };

    const events = ["keydown", "keypress", "keyup"] as const;

    events.forEach(eventType => {
        window.addEventListener(eventType, shiftHandler);
    });

    const app = new App();
    app.render();
}

// @ts-ignore
jQuery(init);


console.log("========================");
console.log("Service worker registration...");
if ("serviceWorker" in navigator) {
    try {
        const url = new URL("./serviceworker.js", window.location.href);
        window.addEventListener("load", function () {
            navigator.serviceWorker.register(url).then(function (registration) {
                console.log("ServiceWorker registration successful with scope: ", registration.scope)
            }).catch(function (err) {
                console.log("ServiceWorker registration failed: ", err)
            })
        });
    } catch (ex) {
        console.log("Failed to add service worker", ex);
    }
} else {
    console.log("Service workers are not supported.")
}
console.log("========================");
